<template>
  <svg :class="svgClass" :style="svgStyle" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    },
    svgStyle() {
      // 当传入 color 时，同时设置 color 与 fill 为内联样式，确保能覆盖 svg 内部的 fill 属性
      return this.color ? { color: this.color, fill: this.color } : {};
    },
  },
};
</script>

<style scoped>
.svg-icon {
  /* width: 1.2rem;
  height: 1.2rem; */
  /* vertical-align: -0.18em; */
  color: #41464f; /* 默认图标颜色 */
  fill: currentColor;
  overflow: hidden;
}
/* 强制覆盖内嵌 svg 路径的 fill，支持通过 color 控制颜色 */
.svg-icon * {
  fill: currentColor !important;
}
</style>
